(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["DEPRECATED-rb-cart-template-simple"]) return;
  try {
    
function popitup(link) {
  var w = window.open(link.href,
        link.target||"_blank",
        'menubar=no,toolbar=no,location=no,directories=no,status=no,scrollbars=no,resizable=no,dependent,width=800,height=620,left=0,top=0');
  return w?false:true; // allow the link to work if popup is blocked
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-cart-template"]) return;
  try {
    
function popitup(link) {
var w = window.open(link.href,
link.target||"_blank",
'menubar=no,toolbar=no,location=no,directories=no,status=no,scrollbars=no,resizable=no,dependent,width=800,height=620,left=0,top=0');
return w?false:true; // allow the link to work if popup is blocked
}

  } catch(e) { console.error(e); }
})();
})();
